module.exports = __webpack_public_path__ + "static/media/icon-email.a4510a1c.svg";